/**
 * MinimalistSummary - Apple-inspired clean summary component
 * Replaces overwhelming emoji-heavy design with minimalist elegance
 */

import React from 'react';
import { motion } from 'framer-motion';
import './MinimalistSummary.css';

interface MinimalistSummaryProps {
  therapyType?: string;
  therapistName?: string;
  duration?: number;
  modality?: 'presencial' | 'online' | 'domicilio';
  date?: string;
  time?: string;
  price?: number;
  showPrice?: boolean;
  compact?: boolean;
}

const MinimalistSummary: React.FC<MinimalistSummaryProps> = ({
  therapyType,
  therapistName,
  duration,
  modality,
  date,
  time,
  price,
  showPrice = true,
  compact = false
}) => {
  
  const formatDate = (dateString: string) => {
    if (!dateString) return '';
    return new Date(dateString + 'T12:00:00').toLocaleDateString('es-CL', {
      weekday: 'long',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <motion.div 
      className={`minimalist-summary ${compact ? 'compact' : ''}`}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <div className="summary-header">
        <h4>Resumen</h4>
      </div>
      
      <div className="summary-content">
        {/* Therapy Type */}
        {therapyType && (
          <div className="summary-row">
            <span className="label">Consulta</span>
            <span className="value">{therapyType}</span>
          </div>
        )}

        {/* Therapist */}
        {therapistName && (
          <div className="summary-row">
            <span className="label">Especialista</span>
            <span className="value">{therapistName}</span>
          </div>
        )}

        {/* Duration */}
        {duration && (
          <div className="summary-row">
            <span className="label">Duración</span>
            <span className="value">{duration} min</span>
          </div>
        )}

        {/* Modality */}
        {modality && (
          <div className="summary-row">
            <span className="label">Modalidad</span>
            <span className="value">
              {modality === 'presencial' ? 'Presencial' : modality === 'domicilio' ? 'Domicilio' : 'Online'}
            </span>
          </div>
        )}

        {/* Date & Time */}
        {date && (
          <div className="summary-row">
            <span className="label">Fecha</span>
            <span className="value">{formatDate(date)}</span>
          </div>
        )}

        {time && (
          <div className="summary-row">
            <span className="label">Hora</span>
            <span className="value">{time}</span>
          </div>
        )}

        {/* Price */}
        {showPrice && price && (
          <div className="summary-divider"></div>
        )}

        {showPrice && price && (
          <div className="summary-row total-row">
            <span className="label total">Total</span>
            <span className="value total">${price.toLocaleString()}</span>
          </div>
        )}
      </div>
    </motion.div>
  );
};

export default MinimalistSummary;